var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecureDataArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#ECFFFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.6418 21.7692L58.6379 24.7653L56.52 55.3975L49.443 54.3127C49.8218 51.7988 50.2351 49.2849 50.6828 46.7709C51.1649 44.2225 51.647 41.8119 52.1291 39.539C52.6457 37.2317 53.145 35.1138 53.6272 33.1853C54.1437 31.2224 54.6259 29.5349 55.0736 28.1229L55.6418 30.0342L52.6974 28.7428L53.9888 28.0713C52.9901 29.621 51.7159 31.3773 50.1662 33.3402C48.5821 35.2688 46.843 37.3178 44.9489 39.4874C43.0893 41.6225 41.1435 43.7749 39.1117 45.9444C37.0799 48.0451 35.0653 50.0941 33.0679 52.0915L24.0797 61.0797L19.3273 56.3273L28.3156 47.3391C30.3129 45.3418 32.3792 43.3444 34.5143 41.347C36.6839 39.3152 38.8362 37.3695 40.9714 35.5098C43.1409 33.6158 45.2072 31.8939 47.1701 30.3442C49.1331 28.7945 50.8722 27.5031 52.3874 26.47L51.6642 27.7097L50.4245 24.8169L52.1291 25.4885C50.0973 26.0739 47.7039 26.711 44.9489 27.3998C42.1939 28.0885 39.2151 28.7256 36.0124 29.3111C32.8097 29.8965 29.5037 30.4475 26.0943 30.9641L25.1645 23.8355L55.6418 21.7692Z",
    fill: "#0F1936"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureDataArrow);
export default __webpack_public_path__ + "static/media/secureDataArrow.f5da5ee27747bab18990e1b0b4a02588.svg";
export { ForwardRef as ReactComponent };